import React from "react";
import "./loading.css";

const Loading1 = () => {
  return <span className="loader"></span>;
};

export default Loading1;
